module.exports = __webpack_public_path__ + "static/media/Picture taken from Cathedral Bell Tower c. 1900s.27fa9cb6.jpg";